import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import Loader from "components/loader/Loader";
import { Link } from "react-router-dom";
import VideoQueModal from "models/VideoQue.modal";

const VideoQuestionsManagement = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    await VideoQueModal.list(parameters)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setDataList(result?.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListData();
  }, [location]);

  // console.log(dataList, "dataListvideoquestion");

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          VideoQueModal.removeVideoQue(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  return (
    <>
      <div className="pt-7 px-4">
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">All Video Questions Management</h3>

                  <div className="d-flex flex-row">
                    {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                    <Input
                      className="mr-4"
                      type="text"
                      placeholder="Search"
                      size="sm"
                    />
                    <Button
                      color="primary"
                      size="sm"
                      to="/admin/videoquestionsmanagement/addvideoquestionsmanagement/"
                      tag={Link}
                      style={{
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                    >
                      +Add
                    </Button>
                  </div>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Question</th>
                      <th scope="col">Category Name</th>
                      <th scope="col">Board</th>
                      <th scope="col"> Class</th>
                      <th scope="col">Subject</th>

                      <th>Action</th>
                    </tr>
                  </thead>

                  {!isLoading && (
                    <tbody>
                      {" "}
                      {isLoading ? (
                        <tr>
                          <td
                            colSpan={12}
                            className="text-center align-middle w-full"
                          >
                            Please wait...
                            <Loader />
                          </td>
                        </tr>
                      ) : dataList?.length > 0 ? (
                        dataList
                          ?.slice()
                          .reverse()
                          .map((item, index) => {
                            return (
                              <tr key={item._id}>
                                <td>{index + 1}</td>
                                <td>{item.question || "-"}</td>

                                {item?.category
                                  ?.slice()
                                  .reverse()
                                  .map((data, index) => {
                                    return (
                                      <td key={index}>{data?.name || "-"}</td>
                                    );
                                  })}

                                {/* Empty columns if categories are less */}
                                {[
                                  ...Array(
                                    Math.max(
                                      0,
                                      4 - (item.category?.length || 0)
                                    )
                                  ),
                                ].map((_, index) => (
                                  <td key={index + item.category?.length}>
                                    {" "}
                                    -{" "}
                                  </td>
                                ))}

                                <td
                                  className="p-0 pr-4"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="eyeTooltip"
                                  >
                                    edit
                                  </UncontrolledTooltip>
                                  <Link
                                    style={{
                                      margin: "0 5px",
                                      fontSize: "15px",
                                      color: "blue",
                                      marginTop: "10px",
                                      display: "inline-block",
                                      // padding: "5px", // Optional: Add padding for better appearance
                                      borderRadius: "30%", // Optional: Make it a circle
                                    }}
                                    id="eyeTooltip"
                                    to={`/admin/videoquestionsmanagement/editvideoquestionsmanagement/${item.id}`}
                                    // tag={Link}
                                  >
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </Link>

                                  <UncontrolledTooltip
                                    placement="top"
                                    target="userTooltip"
                                  >
                                    Delete
                                  </UncontrolledTooltip>
                                  <p
                                    style={{
                                      margin: "0 8px",
                                      fontSize: "15px",
                                      color: "red",
                                      marginTop: "10px",
                                      // backgroundColor: "#f5f5f5",
                                      display: "inline-block",
                                      // padding: "5px", // Optional: Add padding for better appearance
                                      borderRadius: "20%", // Optional: Make it a circle
                                    }}
                                    onClick={() => handleDel(item.id)}
                                    id="userTooltip"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </p>
                                </td>
                              </tr>
                            );
                          })
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="12" style={{ verticalAlign: "middle" }}>
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </Table>
                <CardFooter className="py-4">
                  {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default VideoQuestionsManagement;
